<template lang="html">
  <div class="pageContainer">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="header">
            <h1>Settings</h1>
            <p class="text-danger" v-if="feedback">{{ feedback }}</p>
          </div>
        </div>
        <div class="col-3">
          <div class="list-group"  id="myTab" role="tablist">
            <a href="#profile" class="list-group-item list-group-item-action active" id="profile-tab" data-toggle="tab" role="tab" aria-controls="profile" aria-selected="true">Profile Information</a>
            <a href="#emailAddress" class="list-group-item list-group-item-action" id="emailAddress-tab" data-toggle="tab" role="tab" aria-controls="emailAddress" aria-selected="false">Email Address</a>
            <a href="#password" class="list-group-item list-group-item-action" id="password-tab" data-toggle="tab" role="tab" aria-controls="password" aria-selected="false">Password</a>
            <a href="#connectedAccounts" class="list-group-item list-group-item-action" id="connectedAccounts-tab" data-toggle="tab" role="tab" aria-controls="connectedAccounts" aria-selected="false">Connected Accounts</a>
            <a href="#deleteAccount" class="list-group-item list-group-item-action" id="deleteAccount-tab" data-toggle="tab" role="tab" aria-controls="deleteAccount" aria-selected="false">Delete Account</a>
          </div>
        </div>
        <div class="col-9">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <div class="container">
                <div class="row">
                  <div class="col-8 offset-2">
                    <form>
                      <div class="form-group">
                        <label for="firstName">First Name</label>
                        <input v-model="first" type="text" class="form-control" id="firstName" placeholder="Type your first name">
                      </div>
                      <div class="form-group">
                        <label for="lastName">Last Name</label>
                        <input v-model="last" type="text" class="form-control" id="lastName" placeholder="Type your last name">
                      </div>
                      <div class="form-group">
                        <label for="username">Username</label>
                        <input v-model="username" type="text" class="form-control" id="username" placeholder="Create a unique username">
                      </div>
                      <button id="submitProfileInformationButton" @click.prevent="SubmitProfileInformation" type="submit" class="btn btn-primary"><span>Update</span><i class="d-none fa fa-spin fa-spinner"></i></button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="emailAddress" role="tabpanel" aria-labelledby="emailAddress-tab">
              <div class="container">
                <div class="row">
                  <div class="col-8 offset-2">
                    <form>
                      <div class="form-group">
                        <label for="currentEmailAddress">Current Email Address</label>
                        <span v-if="this.email" class="form-control muted">{{ this.email }}</span>
                      </div>
                      <div class="form-group">
                        <label for="newEmailAddress">New Email Address</label>
                        <input v-model="newEmailAddress" type="email" class="form-control" id="newEmailAddress" placeholder="Type a new email">
                      </div>
                      <div class="form-group">
                        <label for="repeatEmailAddress">Repeat Email Address</label>
                        <input v-model="repeatEmailAddress" type="email" class="form-control" id="repeatEmailAddress" placeholder="Repeat your email address">
                      </div>
                      <button id="submitEmailUpdateButton" @click.prevent="submitEmailUpdate" type="submit" class="btn btn-primary"><span>Update</span><i class="d-none fa fa-spin fa-spinner"></i></button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="password" role="tabpanel" aria-labelledby="password-tab">
              <div class="container">
                <div class="row">
                  <div class="col-8 offset-2">
                    <form>
                      <div v-if="hasPassword" class="form-group">
                        <label for="currentPassword">Current Password</label>
                        <input v-model="currentPassword" type="password" class="form-control" id="currentPassword" placeholder="Type your current password">
                      </div>
                      <div class="form-group">
                        <label for="newPassword">New Password</label>
                        <input v-model="newPassword" type="password" class="form-control" id="newPassword" placeholder="Create a new password">
                      </div>
                      <div class="form-group">
                        <label for="repeatPassword">Repeat Password</label>
                        <input v-model="repeatPassword" type="password" class="form-control" id="repeatPassword" placeholder="retype your new password">
                      </div>
                      <button id="submitPasswordButton" @click.prevent="submitPassword" type="submit" class="btn btn-primary"><span>Update</span><i class="d-none fa fa-spin fa-spinner"></i></button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="connectedAccounts" role="tabpanel" aria-labelledby="connectedAccounts-tab">
              <div class="container">
                <div class="row">
                  <div class="col-8 offset-2">
                    <div class="container">
                      <div class="row">
                        <div class="col-6 text-left">
                          <p>Facebook<br /><small>You are<span v-if="!hasFacebook"> not</span> connected to Facebook</small></p>
                        </div>
                        <div class="col-6 text-right">
                          <button id="connectFacebookButton" v-if="!hasFacebook" @click.prevent="connectAccount('facebook.com')" type="button" name="button" class="btn btn-outline-primary"><span>Connect</span><i class="d-none fa fa-spin fa-spinner"></i></button>
                          <button id="disconnectFacebookButton" v-if="hasFacebook" @click.prevent="disconnectAccount('facebook.com')" type="button" name="button" class="btn btn-primary"><span>Disconnect</span><i class="d-none fa fa-spin fa-spinner"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="deleteAccount" role="tabpanel" aria-labelledby="deleteAccount-tab">
              <div class="container">
                <div class="row">
                  <div class="col-8 offset-2">
                    <form>
                      <div class="form-group">
                        <p>Deleting your account will delete all history and information and you will not be able to retrieve it.</p>
                      </div>
                      <button id="deleteAccountModalButton" type="button" class="btn btn-danger" data-toggle="modal" data-target="#deleteAccountModal"><span>Delete Account</span><i class="d-none fa fa-spin fa-spinner"></i></button>
                      <!-- <button id="deleteAccountButton" @click.prevent="deleteAccount" type="button" name="button" class="btn btn-danger"><span>Delete Account</span><i class="d-none fa fa-spin fa-spinner"></i></button> -->
                      <!-- Modal -->
                      <div class="modal fade" id="deleteAccountModal" tabindex="-1" role="dialog" aria-labelledby="deleteAccountModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="deleteAccountModalLabel">Delete Account</h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <p>We're so sad to see you go! Are you sure you want to delete your account? You will lose all your history and progress. To completely delete everything, simply type your username below:</p>
                              <div class="form-group">
                                <input @keydown.enter.prevent="deleteAccount" v-on:keyup="checkUsernameMatch" v-model="deleteAccountUsername" type="text" class="form-control" id="deleteAccountUsername" placeholder="Type your username here">
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button @click="clearUsername" type="button" class="btn btn-secondary" data-dismiss="modal">Nevermind</button>
                              <button type="button" disabled class="btn btn-danger disabled" @click.prevent="deleteAccount" id="deleteAccountButton"><span>Delete Forever</span><i class="d-none fa fa-spin fa-spinner"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from '@/store/firebaseinit'
import firebase from 'firebase'

export default {
  name: 'Settings',
  data() {
    return {
      first: null,
      last: null,
      username: null,
      email: null,
      feedback: null,
      username: null,
      user: null,
      userInfo: null,
      newEmailAddress: null,
      repeatEmailAddress: null,
      hasFacebook: false,
      hasPassword: false,
      currentPassword: null,
      newPassword: null,
      repeatPassword: null,
      deleteAccountUsername: null,
      goalsToDelete: []
    }
  },
  methods: {
    checkUsernameMatch() {
      if(this.deleteAccountUsername == this.username) {
        $('#deleteAccountButton').attr("disabled", false)
        $('#deleteAccountButton').removeClass('disabled')
      } else {
        $('#deleteAccountButton').attr("disabled", true)
        $('#deleteAccountButton').addClass('disabled')
      }
    },
    clearUsername() {
      this.deleteAccountUsername = null
      $('#deleteAccountButton').attr("disabled", true)
      $('#deleteAccountButton').addClass('disabled')
    },
    deleteAccount() {
      $('#deleteAccountModal').modal('hide')
      $('#deleteAccountModalButton').attr("disabled", true).addClass('disabled')
      $('#deleteAccountModalButton span').addClass('d-none')
      $('#deleteAccountModalButton i').removeClass('d-none')
      var user = firebase.auth().currentUser
      db.collection('users').doc(this.user.uid).delete()
      .then(() => {
        this.deleteGoalHistory(this.user.uid)
        this.deleteGoals(this.user.uid)
        user.delete().then(() => {
          this.$router.push({ name: 'Index' })
        }).catch(error => {
          console.log('Could not delete the user')
        })
      }).catch(error => {
        console.log(error.message)
      })
    },
    deleteGoalHistory(uid) {
      db.collection('goalHistory').where('userId','==',uid).get()
      .then(result => {
        result.forEach(doc => {
          db.collection('goalHistory').doc(doc.id).delete()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    deleteGoals(uid) {
      db.collection('goals').where('userId','==',uid).get()
      .then(result => {
        result.forEach(doc => {
          db.collection('goals').doc(doc.id).delete()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    connectAccount(providerName) {
      $('#connectFacebookButton').attr("disabled", true)
      $('#connectFacebookButton span').addClass('d-none')
      $('#connectFacebookButton i').removeClass('d-none')

      var provider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().currentUser.linkWithPopup(provider)
      .then(result => {
        db.collection('users').doc(result.user.uid).update({
          birthday: result.additionalUserInfo.profile.birthday,
          photoURL: result.user.photoURL,
          facebookToken: result.credential.accessToken
        }).then(() => {
          this.hasFacebook = true
          $('#connectFacebookButton').attr("disabled", false)
          $('#connectFacebookButton span').removeClass('d-none')
          $('#connectFacebookButton i').addClass('d-none')
        }).catch(error => {
          this.feedback = error.message
          $('#connectFacebookButton').attr("disabled", false)
          $('#connectFacebookButton span').removeClass('d-none')
          $('#connectFacebookButton i').addClass('d-none')
        })
      }).catch(error => {
        this.feedback = error
        $('#connectFacebookButton').attr("disabled", false)
        $('#connectFacebookButton span').removeClass('d-none')
        $('#connectFacebookButton i').addClass('d-none')
      })
    },
    disconnectAccount(providerName) {
      $('#disconnectFacebookButton').attr("disabled", true)
      $('#disconnectFacebookButton span').addClass('d-none')
      $('#disconnectFacebookButton i').removeClass('d-none')

      this.user.unlink(providerName)
      .then(() => {
        db.collection('users').doc(this.user.uid).update({
          facebookToken: null
        }).then(() => {
          this.hasFacebook = false
          $('#disconnectFacebookButton').attr("disabled", false)
          $('#disconnectFacebookButton span').removeClass('d-none')
          $('#disconnectFacebookButton i').addClass('d-none')
        }).catch(error => {
          this.feedback = error.message
          $('#disconnectFacebookButton').attr("disabled", false)
          $('#disconnectFacebookButton span').removeClass('d-none')
          $('#disconnectFacebookButton i').addClass('d-none')
        })
      }).catch(error => {
        this.feedback = error
        $('#disconnectFacebookButton').attr("disabled", false)
        $('#disconnectFacebookButton span').removeClass('d-none')
        $('#disconnectFacebookButton i').addClass('d-none')
      })
    },
    SubmitProfileInformation() {
      $('#submitProfileInformationButton').attr("disabled", true)
      $('#submitProfileInformationButton span').addClass('d-none')
      $('#submitProfileInformationButton i').removeClass('d-none')
      if(this.first && this.last && this.username) {

          // check if username is taken
          db.collection('users').where('username','==',this.username).get()
          .then(result => {
            if(result.size == 0) {
              // no one has the username
              this.user.updateProfile({
                displayName: this.first + " " + this.last
              }).then(() => {
                db.collection('users').doc(this.user.uid).update({
                  first: this.first,
                  last: this.last,
                  username: this.username
                }).then(() => {
                  // Successfully updated
                  $('#submitProfileInformationButton').attr("disabled", false)
                  $('#submitProfileInformationButton span').removeClass('d-none')
                  $('#submitProfileInformationButton i').addClass('d-none')
                }).catch(error => {
                  this.feedback = error.message
                  $('#submitProfileInformationButton').attr("disabled", false)
                  $('#submitProfileInformationButton span').removeClass('d-none')
                  $('#submitProfileInformationButton i').addClass('d-none')
                })
              }).catch(error => {
                this.feedback = error.message
                $('#submitProfileInformationButton').attr("disabled", false)
                $('#submitProfileInformationButton span').removeClass('d-none')
                $('#submitProfileInformationButton i').addClass('d-none')
              })
            } else {
              // someone has this username, check if its current user or someone else
              result.forEach(doc => {
                let user = doc.data()
                user.id = doc.id
                if(this.user.uid == user.id) {
                  this.user.updateProfile({
                    displayName: this.first + " " + this.last
                  }).then(() => {
                    db.collection('users').doc(this.user.uid).update({
                      first: this.first,
                      last: this.last,
                      username: this.username
                    }).then(() => {
                      // Successfully updated
                      $('#submitProfileInformationButton').attr("disabled", false)
                      $('#submitProfileInformationButton span').removeClass('d-none')
                      $('#submitProfileInformationButton i').addClass('d-none')
                    }).catch(error => {
                      this.feedback = error.message
                      $('#submitProfileInformationButton').attr("disabled", false)
                      $('#submitProfileInformationButton span').removeClass('d-none')
                      $('#submitProfileInformationButton i').addClass('d-none')
                    })
                  }).catch(error => {
                    this.feedback = error.message
                    $('#submitProfileInformationButton').attr("disabled", false)
                    $('#submitProfileInformationButton span').removeClass('d-none')
                    $('#submitProfileInformationButton i').addClass('d-none')
                  })
                } else {
                  this.feedback = "This username is already taken."
                  $('#submitProfileInformationButton').attr("disabled", false)
                  $('#submitProfileInformationButton span').removeClass('d-none')
                  $('#submitProfileInformationButton i').addClass('d-none')
                }
              })
            }
        }).catch(error => {
          this.feedback = error.message
        })
      } else {
        this.feedback = "Please fill out all fields"
        $('#submitProfileInformationButton').attr("disabled", false)
        $('#submitProfileInformationButton span').removeClass('d-none')
        $('#submitProfileInformationButton i').addClass('d-none')
      }
    },
    submitEmailUpdate() {
      this.feedback = null
      $('#submitEmailUpdateButton').attr("disabled", true)
      $('#submitEmailUpdateButton span').addClass('d-none')
      $('#submitEmailUpdateButton i').removeClass('d-none')
      if(this.newEmailAddress && (this.newEmailAddress == this.repeatEmailAddress)) {
        var user = firebase.auth().currentUser;
        user.updateEmail(this.repeatEmailAddress)
        .then(() => {
          db.collection('users').doc(user.uid).update({
            email: this.repeatEmailAddress
          }).then(() => {
            this.email = this.repeatEmailAddress
            this.repeatEmailAddress = null
            this.newEmailAddress = null
            $('#newEmailAddress').focus()
            $('#submitEmailUpdateButton').attr("disabled", false)
            $('#submitEmailUpdateButton span').removeClass('d-none')
            $('#submitEmailUpdateButton i').addClass('d-none')
          }).catch(error => {
            $('#submitEmailUpdateButton').attr("disabled", false)
            $('#submitEmailUpdateButton span').removeClass('d-none')
            $('#submitEmailUpdateButton i').addClass('d-none')
            this.feedback = error.message
          })
        }).catch(error => {
          $('#submitEmailUpdateButton').attr("disabled", false)
          $('#submitEmailUpdateButton span').removeClass('d-none')
          $('#submitEmailUpdateButton i').addClass('d-none')
          this.feedback = error.message
        });
      }
    },
    submitPassword() {
      this.feedback = null
      $('#submitPasswordButton').attr("disabled", true)
      $('#submitPasswordButton span').addClass('d-none')
      $('#submitPasswordButton i').removeClass('d-none')

      if(this.newPassword == this.repeatPassword) {
        // Update account with password
        if(this.hasPassword) {
          // Check current password then update
          firebase.auth().signInWithEmailAndPassword(this.email, this.currentPassword)
          .then(result => {
            this.user.updatePassword(this.newPassword).then(function() {
              // Update successful.
              this.currentPassword = null
              this.newPassword = null
              this.repeatPassword = null
              $('#currentPassword').focus()
              $('#submitPasswordButton').attr("disabled", false)
              $('#submitPasswordButton span').removeClass('d-none')
              $('#submitPasswordButton i').addClass('d-none')
            }.bind(this)).catch(function(error) {
              // An error happened.
              this.feedback = error.message
              $('#submitPasswordButton').attr("disabled", false)
              $('#submitPasswordButton span').removeClass('d-none')
              $('#submitPasswordButton i').addClass('d-none')
            }.bind(this))
          }).catch(error => {
            this.feedback = error.message
            $('#submitPasswordButton').attr("disabled", false)
            $('#submitPasswordButton span').removeClass('d-none')
            $('#submitPasswordButton i').addClass('d-none')
          })
        } else {
          // Creating a password for the first time
          var credential = firebase.auth.EmailAuthProvider.credential(this.email, this.newPassword);
          firebase.auth().currentUser.linkAndRetrieveDataWithCredential(credential)
          .then(usercred => {
            var user = usercred.user;
            this.hasPassword = true
            this.newPassword = null
            this.repeatPassword = null
            $('#submitPasswordButton').attr("disabled", false)
            $('#submitPasswordButton span').removeClass('d-none')
            $('#submitPasswordButton i').addClass('d-none')
          }).catch(error => {
            this.feedback = error.message
            $('#submitPasswordButton').attr("disabled", false)
            $('#submitPasswordButton span').removeClass('d-none')
            $('#submitPasswordButton i').addClass('d-none')
          })
        }
      } else {
        // Passwords do not match
        this.feedback = 'Your passwords do not match.'
        $('#submitPasswordButton').attr("disabled", false)
        $('#submitPasswordButton span').removeClass('d-none')
        $('#submitPasswordButton i').addClass('d-none')
      }
    }
  },
  created() {
    this.user = firebase.auth().currentUser
    var displayName = this.user.displayName.split(" ")
    this.first = displayName[0]
    this.last = displayName[1]

    db.collection('users').doc(this.user.uid).get()
    .then(result => {
      this.userInfo = result.data()
      this.username = this.userInfo.username
      this.email = this.userInfo.email
    })
    this.user.providerData.forEach(item => {
      if(item.providerId == 'password') {
        this.hasPassword = true
      } else if(item.providerId == 'facebook.com') {
        this.hasFacebook = true
      }
    })
  },
}
</script>

<style lang="css" scoped>

.header {
  margin: 25px 0;
}
.form-control.muted {
  background-color: #e9ecef;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Settings.vue